import { Component,Fragment } from "react"
import React from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { withRouter } from 'react-router-dom';
import { saveEnquiryData } from "../../actions/contact"
import { connect } from "react-redux"; 
import { bindActionCreators } from "redux";
import { toast } from 'react-toastify';



class Enquiry extends Component {

    constructor (props) {
        super (props)
        this.state={
            enquire_mobile : '',
            enquire_firstname : '',
            enquire_email : '',
            enquire_country : '',
            enquire_city : '',
            enquire_message : ''



        }
        this.validator = new SimpleReactValidator();

    }

handleSubmit =(event)=>{

    event.preventDefault();
    if (this.validator.allValid()) {
    
         const { connection_id } = this.props
         const options = {
            connection_id:connection_id,
            name:this.state.enquire_firstname,
            email:this.state.enquire_email,
            city:this.state.enquire_city,
            state:this.state.enquire_country,
            subject:'',
            message:this.state.enquire_message
         }

        this.props.saveEnquiryData(options)
    
        
        setTimeout(function(){
            if (!!!this.props.error) {
                toast.success(" Successful submitted");
                this.props.history.goBack()
            }
        }.bind(this), 500);
    
    } else {
        this.validator.showMessages();
        this.forceUpdate();
    }
        }
        handleChange(event) {
            
            this.setState({ [event.target.id]: event.target.value });
    
        }


    render(){
        return(
            <Fragment>
            <div style={window.innerWidth > 560 ? {marginLeft:'36%'} : {marginLeft:'0%'}}>
            <section className="tab-product m-0" style={window.innerWidth > 560 ? {width:'50%'}:{width:'100%',paddingTop:10}}>
                <h2 style={{marginTop:30, paddingBottom:20,textAlignLast:"center"}}>Enquiry Submission</h2>
        <div className='container'>
            <form>
            <div className='row'>
                <div className='col'>
                    <label>Mobile No*</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' onChange={(e) => this.handleChange(e)} id='enquire_mobile'  className='form-control' />
                    {this.validator.message('Mobile No', this.state.enquire_mobile, 'required|phone')}

                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>First Name*</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' onChange={(e) => this.handleChange(e)}  className='form-control' id='enquire_firstname' />
                    {this.validator.message('First Name', this.state.enquire_firstname, 'required|alpha_space')}

                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>Last Name</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' onChange={(e) => this.handleChange(e)}  className='form-control' />
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>Email*</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' onChange={(e) => this.handleChange(e)}  className='form-control' id='enquire_email'  />
                    {this.validator.message('Email', this.state.enquire_email, 'required|email')}


                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>Country*</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' onChange={(e) => this.handleChange(e)}  className='form-control' id='enquire_country' />
                    {this.validator.message('Country name', this.state.enquire_country, 'required|alpha_space')}

                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>City*</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <input type='text' className='form-control' onChange={(e) => this.handleChange(e)} id='enquire_city' />
                    {this.validator.message('City name', this.state.enquire_city, 'required|alpha_space')}

                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <label>Message</label>
                </div>
            </div>
            <div className='row'>
                <div className='col' style={{padding:10}}>
                    <textarea onChange={(e) => this.handleChange(e)} id='enquire_message'  className='form-control' ></textarea>
                </div>
            </div>
            <div className='row'>
                <div className='col'>
                    <button type='submit'  onClick={(e)=>this.handleSubmit(e)} className='btn btn-solid'>SUBMIT</button>
                </div>
            </div>
            </form>

        </div>
        </section>
        </div></Fragment>)
    }

} 


const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    error: state.user.error,
    connection_id: state.tenant.connection_id,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { saveEnquiryData },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Enquiry));